<div class="full p-12">
    <div class="empty-view">
        <div><mat-icon svgIcon="noData"></mat-icon></div>
        <h6>{{ 'view.empty.title' | translate }}</h6>
        <div class="please-select">{{ 'view.empty.note' | translate }}</div>
    </div>
</div>